import Utils from "../../../utility";

const initialState = {
  propertyOwnerList: [],
  storeList: [],
  order: "DESC",
  sortField: "addDate",
  offset: 1,
  take: 20,
  search: "",
  count: 0,
};
export const propertyOwnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.PROPERTY_OWNER}`:
      return {
        ...state,
        ...action.payload,
      };
    case `${Utils.ActionName.RESET_PROPERTY_OWNER}`:
      return initialState;
    default:
      return { ...state };
  }
};
